import { FETCH_NAVIGATION_DATA } from './types';
import axios from 'axios';
const apiUrl = 'https://blog-api.bunnyufo.net/navigation';

export const fetchData = (data) => {
  return {
    type: FETCH_NAVIGATION_DATA,
    data
  }
};

export const fetchNavigationData = () => {
  return (dispatch) => {
    return axios.get(apiUrl)
      .then(response => {
        dispatch(fetchData(response.data))
      })
      .catch(error => {
        throw(error);
      });
  };
};
